import { UserCard } from '@widgets/user';
import type { User } from '@entities/user';

type UserInfoAdminProps = {
  user: User;
  editLink: string;
};

export const UserInfoAdmin = ({ user, editLink }: UserInfoAdminProps) => {
  return (
    <UserCard
      editLink={editLink}
      isEdit
      firstName={user.profile.firstName}
      lastName={user.profile.lastName}
      email={user.email}
      group={user.role.name}
      phone={user.profile.phone}
    />
  );
};
